import React from 'react';
import Form from 'antd/lib/form';
import Select from 'antd/lib/select';
import 'antd/lib/select/style/index.css';
var InputIsTeam = function (props) { return (React.createElement(Form.Item, { label: 'Category type', extra: !props.initialValue && 'Cannot be changed after category is created', colon: false }, props.form.getFieldDecorator('isTeamCategory', {
    initialValue: !!props.initialValue ? 1 : 0,
    rules: [{
            required: true,
            message: 'Please set the type for this category',
        }, {
            type: 'number',
        }],
})(React.createElement(Select, { size: 'large', disabled: props.isDisabled },
    React.createElement(Select.Option, { value: 0 }, "Individual category"),
    React.createElement(Select.Option, { value: 1 }, "Team category"))))); };
export default InputIsTeam;



//////////////////
// WEBPACK FOOTER
// ./src/pages/WorkspaceEvent/FormCategoryPage/FormCategory/InputIsTeam.tsx
// module id = 1173
// module chunks = 0